module.exports = __webpack_public_path__ + "assets/password.4c2d6175.svg";